// Central brand + contact constants for Inove Tech

export const WHATSAPP_NUMBER = "557730175377";

export const WHATSAPP_MESSAGES = {
  main: "Olá, vim pelo site. Gostaria de falar sobre um problema no meu celular.",
  schedule: "Olá, vim pelo site. Quero agendar um horário.",
};

export const buildWhatsAppLink = (message = WHATSAPP_MESSAGES.main) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const CONTACT = {
  instagram: "https://www.instagram.com/inovetechvca/",
  tiktok:
    "https://www.tiktok.com/@inovetechvca?is_from_webapp=1&sender_device=pc",
  email: "contato@inovetechvca.com.br",
  googleReview: "https://g.page/r/CfnYoKPKo54oEAE/review",
  address: "Av. Jorge Teixeira, 29 - Lojas 09/10 Térreo, Vitória da Conquista - BA",
  addressLines: [
    "Edf. Candeias Medical Center - Lojas 09/10 Térreo",
    "Av. Jorge Teixeira, 29 - LJ 09/10 Térreo",
    "Vitória da Conquista - BA",
  ],
  hours: ["Seg. a Sex., 9h às 17:30", "Sáb., 9h às 12h"],
  company: {
    razaoSocial: "Inove Tech",
    cnpj: "59.164.317/0001-06",
    city: "Vitória da Conquista - BA",
  },
};

export const MAP_EMBED =
  "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1922.7!2d-40.829408!3d-14.862295!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTTCsDUxJzQ0LjMiUyA0MMKwNDknNDUuOSJX!5e0!3m2!1spt-BR!2sbr!4v1";

// Local brand assets (public/).
export const IMAGES = {
  logo: "/logo.jpeg",
  power: "/logo_power.png",
  hero: "/hero_phones.jpeg",
  tela: "/img_tela.jpeg",
  aparelho: "/img_apple_lineup.webp",
  bateria: "/img_bateria.webp",
  placa: "/img_placa.webp",
};
